import { TextField } from '@mui/material'
import { type FC, useId } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { LabeledField } from 'src/features/labelMaster/form/LabeledField'
import { type LabelMasterForm } from './labelMasterForm'

type Props = {
  control: Control<LabelMasterForm>
}

export const Name: FC<Props> = ({ control }) => {
  const id = useId()

  return (
    <LabeledField label="ラベルマスタ名" htmlFor={id} required>
      <Controller
        name="name"
        control={control}
        rules={{
          required: '1文字以上入力してください',
          maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            id={id}
            fullWidth
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </LabeledField>
  )
}
